<ada-container
	#MainContainer
	id="MainContainer"
	[horizontalSpacing]="'Medium'"
	[padding]="'1rem 1rem 1rem 1rem'"
	[verticalSpacing]="'Medium'"
>
	<ada-container
		#Container4
		id="Container4"
		[colCount]="0"
		[horizontalSpacing]="'Small'"
		[verticalAlignmentOfChildren]="'Middle'"
	>
		<ada-text
			#Text5
			id="Text5"
			[content]="'Month by Week Settings'"
			[fontWeight]="'Bold'"
		/>
		<ada-signpost
			#Signpost1
			id="Signpost1"
			[icon]="'faInfoCircleOutline'"
		>
			<ada-text
				#Text1
				id="Text1"
				[content]="'This Schedule will occur once every X months on the Yth day of the week on the Zth week of the month.'"
			/>
		</ada-signpost>
	</ada-container>
	<ada-container
		#Container5
		id="Container5"
		[colCount]="4"
		[horizontalSpacing]="'Medium'"
		[verticalSpacing]="'Medium'"
	>
		<ada-text
			#Text2
			id="Text2"
			[content]="'Recurring Interval in Months'"
		/>
		<ada-container
			#Container3
			id="Container3"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-input
				#RecurringIntervalInMonthsInput
				id="RecurringIntervalInMonthsInput"
				[debounce]="'500'"
				[isDisabled]="isDisabled"
				[max]="'127'"
				[min]="'1'"
				[placeholder]="'Number of months'"
				[showAsFullWidth]="true"
				[type]="'Number'"
				[value]="numberOfMonths"
				(valueChange)="setNumberOfMonths($event)"
			/>
		</ada-container>
		<ada-text
			#Text3
			id="Text3"
			[content]="'Day of the Week'"
		/>
		<ada-container
			#Container2
			id="Container2"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-combo
				#DayOfTheWeekInput
				id="DayOfTheWeekInput"
				[isDisabled]="isDisabled"
				[options]="dayOptions"
				[showAsFullWidth]="true"
				(valueChange)="setDayOfWeek($event)"
			/>
		</ada-container>
		<ada-text
			#Text4
			id="Text4"
			[content]="'Week of the Month'"
		/>
		<ada-container
			#Container1
			id="Container1"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-input
				#WeekOfTheMonthInput
				id="WeekOfTheMonthInput"
				[debounce]="'500'"
				[isDisabled]="isDisabled || isLastWeek"
				[max]="'4'"
				[min]="'1'"
				[showAsFullWidth]="true"
				[type]="'Number'"
				[value]="weekOfMonth"
				(valueChange)="setWeekOfMonth($event)"
			/>
		</ada-container>
		<ada-text
			#Text6
			id="Text6"
			[content]="'Last Week of the Month'"
		/>
		<ada-container
			#Container6
			id="Container6"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-toggle-switch
				#IsLastWeekToggle
				id="IsLastWeekToggle"
				[isDisabled]="isDisabled"
				[isToggled]="isLastWeek"
				(isToggledChange)="setIsLastWeek($event)"
			/>
		</ada-container>
	</ada-container>
</ada-container>
